import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Sends a GA4 page_view event on every SPA route change.
 * We disabled automatic page_view in the gtag config (send_page_view: false)
 * so this hook controls it manually for accurate SPA tracking.
 */
export const useGA4PageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const gtag = (window as any).gtag;
    if (typeof gtag === 'function') {
      gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location.pathname, location.search]);
};
